import { IPopupList } from "forms/helpers/interface.helper";
import { driver, admin, agent, driverVerify } from "./constant.utils";

const popupItems: any = {
  driver: driver,
  admin: admin,
  agent: agent,
  driverVerify: driverVerify
};

export default popupItems;
